<script>
    import {formStateMixin} from 'bootstrap-vue/src/mixins/form-state';
    import EmptyValueMixin from '@components/form/mixins/EmptyValueMixin';
    import {validateDateFormat} from '@js/functions/date';

    export default {
        mixins: [EmptyValueMixin, formStateMixin],
        model: {
            prop: 'date',
            event: 'change',
        },
        props: {
            date: {
                type: String,
                default: null,
                validator: validateDateFormat,
            },
            id: {
                type: String,
                default: '',
            },
            maxDate: {
                type: String,
                default: null,
                validator: validateDateFormat,
            },
            minDate: {
                type: String,
                default: null,
                validator: validateDateFormat,
            },
        },
        emits: ['change'],
        computed: {
            additionalInputAttributes() {
                const attributes = {};
                if (this.id) {
                    attributes.id = this.id;
                }
                if (this.minDate) {
                    attributes.min = this.minDate;
                }
                if (this.maxDate) {
                    attributes.max = this.maxDate;
                }
                return attributes;
            },
        },
        methods: {
            handleChange(value) {
                this.$emit('change', this.getValueOrEmpty(value));
            },
        },
    }
</script>
